<template>
	<div>
		

			<div style="margin-top: 20px; margin-bottom: 20px;">
				<h4 class="h_hei">展会快讯</h4>
				<div class="row" v-for="(item, index) in list_c" :key="index" style="margin-bottom: 20px; margin-top: 20px;" @click="route1(item.key)">

					<div class="col-8">
						<h4 style="line-height: 25px; font-size: 16px;">{{item.value_a}}</h4>
						<h6>{{item.value_b}}</h6>
					</div>
					<div class="col-4">
						<img style="width: 100%; height: 100px;border-radius:3%;"
							:src="item.value_c" />
					</div>
				</div>

				

			</div>



			<div style="margin-top: 20px;">
				<img style="width: 100%;" src="https://img.hsnms.com/20220419/1650333647.jpg">
			</div>
			<div style="line-height: 30px; text-align: center; margin-top: 30px; margin-bottom: 30px;">
				<div>汇聚台州房产媒体力量，搭建优质楼盘线上展厅</div>
				<div>为老百姓提供安心选房大平台</div>
				<div
					style="text-indent:2em; font-size: 12px; color: #C0C0C0; text-align: left; line-height: 20px; margin-top: 15px;">
					本网站所刊载的各类内容(包括但不仅限于文字、图片、图表)仅供参考使用，并不构成任何投资建议。对于访问者根据本网站提供的信息所做出的一切行为，本网站不承担任何责任。</div>
				<div style="margin-top: 20px;">Copyright © 2022 台州城市网</div>
			</div>

		</div>


	</div>
</template>

<script>
	export default {
		data() {
			return {
				dialogToAdd: false,
				itemForm: {
					t1:"",
					t2:"",
					name: '',
					tel: '',
				},
				list_a:[],
				list_b:[],
				list_c:{},
				list_d:[],
				list_e:[],
				list_f:[],
				tabPosition: 'top',
				usable: '1',
				tabs: [{
						name: '1',
						label: '品牌馆日'
					},
					{
						name: '2',
						label: '领取优惠'
					}
				]
			}
		},
		mounted() {
			this.listc()
		},
		methods: {
			handleClick(tab) {
				console.log(tab)
			},
			add_order(itm){
				console.log(itm)
				this.itemForm.t1=itm.value_a
				this.itemForm.t2=itm.value_b
				//dialogToAdd
				this.dialogToAdd=true;
			},
			
			
			listc() {
				this.$api.getAPI("data/page/15?appid=20220425&type_id=202204251001", {}).then(res => {
					console.log(res.data)
					if(res.data.code==200){
						var datas = res.data.data.models.detailedjson;
						this.list_c=datas
						console.log("cccccccccccccccccccc")
						console.log(datas)
					}
				})
			},
			route1: function(myurl) {
				window.open(myurl, "_blank");
			},
			topages(itme){
				this.$router.push({
					path: 'wyfc_show',
					query: {
						id: itme.id
					}
				});
			},
		}
	}
</script>

<style>
	.header {
		height: 15rem;
		color: #fff;
		background: url("http://www.baiduhrb.com/fjh/images/user_bg.png");
		background-size: 100% 100%;
	}

	.header .logo {
		display: block;
		float: left;
		margin-left: .8rem;
		margin-top: -4rem;
	}

	.header .logo img {
		position: relative;
		overflow-x: hidden;
		width: 45%;
		height: auto;
		top: 0px;
	}

	.m-slider {
		overflow-x: hidden;
		position: relative;
		margin-top: -10rem;
		border-radius: .45em;
	}

	.zhibo {
		background: #c5114f;
		text-align: center;
		color: #fff;
	}

	.loupan {
		opacity: 0.6;
		background: #c5114f;
		text-align: center;
		color: #fff;
	}

	.jiage {
		background: #c5114f;
		text-align: center;
		color: #fff;
	}

	.h_hei {
		border-left: 5px solid #c5114f;
		padding-left: 5px;
	}

	.container-fluid {
		margin-top: 0px !important;
		max-width: 1200px;
	}

	.el-tabs__item {
		font-size: 16px !important;


	}

	.el-tabs__item is-top is-active {
		width: 50% !important;
	}

	.el-carousel__container {
		height: 200px !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/wyfc/wyfc_news.vue